module.exports = __webpack_public_path__ + "static/img/role0013.7e51fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role0013.jpg
// module id = +74W
// module chunks = 1